/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components  */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import StyleConfig from '@components/UI/Common/StyleConfig';
import SingleImage from '@components/Card/SingleImage';

/**
 * Returns the Top Banner Event .
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Content from API
 * @param {string} region - Region of page
 * @param {string} language - Lang of page
 * @returns {ReactElement} TopBannerEvent component
 */

const TopBannerEventMMM = ({ section, region, language, pageName }) => {
  const sectionContent = section.sectionContent;
  const isMobile = useMediaQuery({ maxWidth: 960 });
  const styles = {
    default: 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
    'without-bottom-angle': '',
    '': 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
  };

  return (
      <Box
        display={'grid'}
        // mb={'70px'}
        pos={'relative'}
        h={{ base: '100%', md: 'auto' }}
        // maxH={620}
        // minH={{ base: 550 }}
        bgColor={{
          base: 'transparent',
          lg: 'transparent',
        }}
      >
        <Box height={'auto'} w={'100%'}>
          <Box
            alignItems={'center'}
            display={'flex'}
            h={{
              // base: '124.97vw',
              base: '88vw',
              sm: '500px',
            }}
            minH={{
              base: '70.9375vw',
              sm: '500px',
            }}
            backgroundRepeat="no-repeat"
            bgColor={{
              base: '#03354A',
              sm: '#03354A',
            }}
            bgGradient="linear-gradient(90deg, #03354A 0%, #03354A 100%)"
            backgroundSize={{ base: 'cover', md: 'cover' }}
            backgroundPosition={{
              base: '0px -10px',
              sm: '0px -10px',
              lg: 'top center',
              xl: '0',
            }}
            backgroundImage={{
              md: sectionContent[0]?.image?.url,
              base:
                sectionContent[0]?.mobileImage?.url ||
                sectionContent[0]?.image?.url,
              // ? show right of image in desktopImage when there is no mobileImage
            }}
            mb={{ base: '0', xl: '0' }}
            clipPath={styles[sectionContent.style]}
          >
            {isMobile && (
              <Flex position="absolute" left="52%" ml="2%">
                <SingleImage
                  sectionContent={sectionContent[1]}
                  region={region}
                  lang={language}
                  w="90%"
                  my="0"
                />
              </Flex>
            )}
            {!isMobile && (
              <Flex
                flexDirection="row"
                p={{ base: '7px', md: '0 0 0 5%' }}
                w={{ base: '100%', sm: '100%', md: '100%' }}
                maxW={{
                  base: 'auto',
                  md: '100%',
                }}
                display={{
                  base: 'none',
                  sm: 'none',
                  lg: 'flex',
                }}
              >
                <Box flex="33.33%"></Box>
                <Box flex="33.33%">
                  <SingleImage
                    sectionContent={sectionContent[1]}
                    region={region}
                    lang={language}
                  />
                </Box>
                <Box flex="33.33%" textAlign="center" justifyContent="center">
                  <SingleImage
                    sectionContent={sectionContent[2]}
                    region={region}
                    lang={language}
                  />
                  <Box
                    fontSize={{
                      base: '16px',
                      md: language === 'en' ? '22px' : '18px',
                    }}
                    fontFamily="FedraSansStd-book"
                    fontWeight="600"
                    mt={2}
                    mb="20px"
                    color="#FFFFFF"
                  >
                    {StructuredTextContent(sectionContent[3]?.body?.value)}
                  </Box>
                  <Flex placeContent="center" mt="20px">
                    <SimpleButton
                      style={sectionContent[4]}
                      region={region}
                      lang={language}
                      mb="10px"
                      // w={{ base: '163px', md: '198px' }}
                      textAlign="center"
                    />
                  </Flex>
                  {sectionContent[5] && (
                  <Box
                    fontSize={{
                      base: '16px',
                      md: '16px',
                    }}
                    width="50%"
                    fontFamily="FedraSansStd-book"
                    fontWeight="500"
                    textTransform="uppercase"
                    m="0 auto"
                    color="#FFFFFF"
                  >
                    {StructuredTextContent(sectionContent[5]?.body?.value)}
                  </Box>
                  )}
                </Box>
              </Flex>
            )}
          </Box>

          {isMobile && (
            <Flex
              display={{
                base: 'flex',
                sm: 'flex',
                md: 'flex',
                lg: 'none',
                xl: 'none',
              }}
              flexDirection="column"
              verticalAlign={'center'}
              w={{ base: '100%', sm: '80%', md: '96%', lg: '50%' }}
              p={{ base: '0px 15px', md: '30px' }}
              fontSize={{
                sm: '44px',
                base: '30px',
              }}
              color={'#28231e'}
              fontFamily="FedraSansStd-A-medium"
              bgColor="#03354A"
              bgGradient="linear-gradient(90deg, #03354A 0%, #03354A 100%)"
              pos="relative"
              top="0px"
            >
              <Box flex="33.33%" textAlign="center" justifyContent="center">
                {/* <SingleImage
                  sectionContent={sectionContent[1]}
                  region={region}
                  lang={language}
                  w="58%"
                  my="0"
                /> */}
                <SingleImage
                  sectionContent={sectionContent[2]}
                  region={region}
                  lang={language}
                  w="53%"
                  my="0"
                />
                <Box
                  fontSize={{
                    base: '18px',
                    md: language === 'en' ? '22px' : '18px',
                  }}
                  fontFamily="FedraSansStd-book"
                  fontWeight="600"
                  mt="30px"
                  mb="20px"
                  color="#FFFFFF"
                >
                  {StructuredTextContent(sectionContent[3]?.body?.value)}
                </Box>
                <Flex placeContent="center" mt="20px" mb="20px">
                  <SimpleButton
                    style={sectionContent[4]}
                    region={region}
                    lang={language}
                    mb="10px"
                    // w="163px"
                    // h="44px"
                    textAlign="center"
                    // minH="44px"
                    // p="7px 0px"
                  />
                </Flex>
                {sectionContent[5] && (
                <Box
                  fontSize={{
                    base: '16px',
                    md: '16px',
                  }}
                  width="64%"
                  fontFamily="FedraSansStd-book"
                  fontWeight="500"
                  textTransform="uppercase"
                  m="0 auto 40px auto"
                  color="#FFFFFF"
                >
                  {StructuredTextContent(sectionContent[5]?.body?.value)}
                </Box>
                )}
              </Box>
            </Flex>
          )}
        </Box>
        <style global jsx>
          {`
          #event-description h2 {
            font-size: 27px;
            color: #28231e;
            font-family: 'FedraSansStd-medium';
            padding: 15px 0 0 0;
          }
          #donate-button a {
            color:#cf4520;
            text-decoration:underline;
          }
          #donate-button a:hover {
            text-decoration:none;
          }
          .closeMessage {
            color: black;
            margin-top: 5px;
            font-size: 16px;
          }
          .closeMessage a {
            color: #cf4824;
          }
          @media (max-width: 767px) {
            #event-description h2 {
              font-size: 20px;
          }        
        `}
        </style>
      </Box>
  );
};

export default TopBannerEventMMM;
